import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter, HostListener} from '@angular/core';

import {LogService} from '../../../../services/log.service';


@Component({
	selector: 'sidenav',
	templateUrl: './sidenav.component.html',
	styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit, AfterViewInit {
	constructor(
		private log: LogService
	) {}



	// @Input() label = '';
	// @Input() link = '';
	// @Output() linkClick = new EventEmitter();


	ngOnInit() {
	}


	ngAfterViewInit() {
		// console.log('this.label');
		// console.log(this.label);
		// console.log('this.link');
		// console.log(this.link);
	}


	sidenavChanged() {
// TODO
		console.log('sidenavChanged');
		// this.updateFilmList(null);
		// this.initFromAllUsers();
		// this.scrollToTop();
		// this.updateSettings();
	}


	openSidenav() {
		// this.editing = true;
		document.getElementById('sidenav').style.marginLeft = '0';
		document.getElementById('sideOverlay').style.display = 'block';
	}


	closeSidenav() {
		// this.editing = false;
		document.getElementById('sidenav').style.marginLeft = '-16rem';
		document.getElementById('sideOverlay').style.display = 'none';
	}


	toggleSidenav() {
		if (this.isSidenavOpen) {
			this.closeSidenav();
		} else {
			this.openSidenav();
		}
	}


	get isSidenavOpen(): boolean {
		return document.getElementById('sideOverlay').style.display === 'block';
	}


}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/sidenav/sidenav.component.ts